const miscReducerDefaultState = {
  users: ["LOADING..."],
  shoots: ["LOADING..."],
  roles: ["LOADING..."],
  allRoles: ["LOADING..."],
  locations: ["LOADING..."],
  equipment: ["LOADING..."],
  companies: ["LOADING..."],
  clients: ["LOADING..."],
  networks: [],
  childParentRoles: null,
}

export default (state = miscReducerDefaultState, action) => {
  switch (action.type) {
    case "MISC::DATA::SET":
      return {
        ...state,
        [action.property]: action.data,
      }
    case "MISC::DATA::PUSH":
      return {
        ...state,
        [action.property]: [...state[action.property], action.data],
      }
    case "SET_CHILD_PARENT_ROLES":
      return {
        ...state,
        childParentRoles: action.data,
      }
    default:
      return state
  }
}
